var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPythagoreanSquareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_643_1954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5461 0.333313H11.1276V9.68877H21.5461V0.333313Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4186 10.3254H0V19.6808H10.4186V10.3254Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5461 10.3254H11.1276V19.6808H21.5461V10.3254Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5461 20.3112H11.1276V29.6666H21.5461V20.3112Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6666 10.3254H22.248V19.6808H32.6666V10.3254Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07901 0.333313H10.4186V9.68877H0V3.09814C0 1.56906 1.37617 0.333313 3.07901 0.333313Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.3112H10.4186V29.6666H3.07901C1.38312 29.6666 0 28.4309 0 26.9018V20.3112Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 29.6666H22.248V20.3112H32.6666V26.9018C32.6666 28.4246 31.2905 29.6666 29.5876 29.6666Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6666 9.68878L22.248 9.68878V0.333321L29.5876 0.333321C31.2835 0.333321 32.6666 1.56907 32.6666 3.09814V9.68878Z",
    fill: "#C0B9F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_643_1954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.6667,
    height: 29.3333,
    fill: "white",
    transform: "translate(0 0.333313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythagoreanSquareIcon);
export default __webpack_public_path__ + "static/media/pythagorean-square-icon.8cb0307d025f0a4a6ec074832576f593.svg";
export { ForwardRef as ReactComponent };